import * as React from "react";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { useStateContext } from "../contexts/ContextProvider";

export default function Ratings({ rate }) {
  const { itemRating } = useStateContext();

  return (
  
    <Stack spacing={1}>
        {console.log(itemRating)}
      <Rating
        name="half-rating-read"
        value={itemRating}
        precision={0.1}
        readOnly
      />
    </Stack>
  );
}
